import {PayMethod} from "../types/types";


export const getRefundTypeName = (type: PayMethod) => {
    switch (type) {
        case 'CARD':
            return '카드 취소';
        case 'TRANSFER':
            return '계좌 환불';
        case 'NAVER':
            return '네이버페이 결제 취소';
        case 'KAKAO':
            return '카카오페이 결제 취소';
        default:
            return '주문 취소';
    }
}